<template>
  <v-container class="cgv" style="max-width: 940px;">
    <h1>
      Conditions Générales de Vente
    </h1>
    <h3 class="overline">Date de la dernière mise à jour: {{updatedAt.toISOString().split('T')[0]}}</h3>
    <v-skeleton-loader
      v-if="isLoading"
      class="mx-auto"
      :height="120"
      type="article"
    ></v-skeleton-loader>
    <div class="cgv_content" v-html="content"></div>
  </v-container>
</template>

<script>
import axios from 'axios'
import MarkdownIt from 'markdown-it'

export default {
  data: () => ({
    isLoading: true,
    content: '',
    updatedAt: new Date(0)
  }),
  async mounted () {
    this.$vuetify.goTo(0)
    const {data} = await axios.get('/strapi/pages/60b6b66f8a21ed2dc3bd31a4')
    this.updatedAt = new Date(data.updatedAt)
    const md = new MarkdownIt()
    this.content = md.render(data.Content)
    this.isLoading = false
  }  
}
</script>

<style>
.cgv_content {
  margin-top: 3em;
}

.cgv td {
  padding: 0 1em;
}

.cgv table {
  margin: 1em 0;
}

.cgv h1 {
  margin-top: 1em;
}

.cgv tr:nth-child(2n) {
  background-color: #eee;
}
</style>